// Groupon.Utils.unparam:

function mUnparam(str = location.search) {
  if (typeof str !== 'string') {
    throw new TypeError(
      `unparam needs a string, but got ${JSON.stringify(str)}`
    );
  }
  const data = {};

  const keyPairs = str.replace(/\+/g, '%20').split('&');
  for (const keyVal of keyPairs) {
    const tuple = /^\??([^=]*)=(.*)/.exec(keyVal);
    if (!tuple) {
      continue;
    }
    try {
      data[decodeURIComponent(tuple[1])] = decodeURIComponent(tuple[2]);
    } catch (error) {}
  }
  return data;
}

module.exports = mUnparam;
